import { NotificationDto } from '@bannerflow/types.notification-service';
import { isSystemNotification } from './types.utils';

export function getSenderId(notification: NotificationDto): string {
  if (isSystemNotification(notification)) {
    return 'SYSTEM';
  }

  return (
    notification.sender.id ??
    notification.sender.name ??
    notification.sender.type.toString()
  );
}
